import { FormRow, P } from 'ia-react-core';
import styled from 'styled-components';

export const StyledLastRow = styled(FormRow)`
  padding-top: 13px;
`;

export const StyledControlMessageText = styled(P)`
  margin-bottom: 13px;
  display: inline-block;
`;
